

















import { Vue, Component } from 'vue-property-decorator'
import DraftLibrary from '../modules/DraftLibrary.vue'
import OnlineLibrary from '../modules/OnlineLibrary.vue'

@Component({
  components: { DraftLibrary, OnlineLibrary }
})
export default class ProperNoun extends Vue {
  private activeKey: string = '1'
}
